import { createContext, useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { fetchCurrentUser, getUserDetails } from "../Redux/Slice/Settings/UserSlice/UserSlice";
import { useDispatch, useSelector } from "react-redux";

const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { CurrentUser } = useSelector(getUserDetails);
  // console.log("CurrentUser in session context:", CurrentUser);
  const token = sessionStorage.getItem("access_token");
  const [session, setSessionState] = useState({
    ChatUserId: null,
    user: null,
    isChat: null,
    LoginId: null,
    isAdmin: null,
    BusinessType: null,
    BusinessId: null,
    IsSuperAdmin: "",
    CanGenerateCommission: false,
    Currency: sessionStorage.getItem("Currency") || sessionStorage.getItem("currency") || "PKR",
  });
  const [loading, setLoading] = useState(!!sessionStorage.getItem("access_token"));
  const [reponseErorr, setResponseError] = useState(false);

  const setSession = data => {
    if (typeof data === "function") {
      setSessionState(data);
    } else {
      setSessionState(prev => ({ ...prev, ...data }));
    }
  };

  useEffect(() => {
    if (token) {
      const module = sessionStorage.getItem("Module") || "CRM";

      dispatch(fetchCurrentUser(module))
        .unwrap()
        .catch(() => {
          setLoading(false);
          setResponseError(true);
        });
      // .finally(() => {
      //     setLoading(false);
      // });
    }
  }, [dispatch, token]);

  useEffect(() => {
    if (CurrentUser) {
      const currency = CurrentUser?.Currency || sessionStorage.getItem("Currency") || "PKR";
      if (CurrentUser?.Currency) {
        sessionStorage.setItem("Currency", CurrentUser.Currency);
      }
      setSessionState({
        user: CurrentUser?.UserRoles,
        LoginId: CurrentUser?.LoginId,
        isAdmin: CurrentUser?.IsAdmin,
        CreateInBoth: CurrentUser?.BothSystemsAccess,
        AllowCrmSystem: CurrentUser?.AllowCrmSystem,
        AllowErpSystem: CurrentUser?.AllowErpSystem,
        BusinessType: CurrentUser?.BusinessType,
        BusinessId: CurrentUser?.BusinessId,
        IsSuperAdmin: CurrentUser?.IsSuperAdmin,
        ChatUserId: CurrentUser?.ChatUserId,
        ChatBusinessId: CurrentUser?.ChatBusinessId,
        isChat: CurrentUser?.IsChat,
        CanGenerateCommission: CurrentUser?.CanGenerateCommission,
        Currency: currency,
      });
    }
  }, [CurrentUser]);

  return (
    <SessionContext.Provider value={{ session, setSession, loading, setLoading, reponseErorr }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => {
  const ctx = useContext(SessionContext);
  if (!ctx) {
    throw new Error("useSession must be used within a SessionProvider");
  }
  return ctx;
};

SessionProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
